// Modem Recovery — per-employee daily ledger. Shared constants + helpers.

// Order matters here — it's the order fields render in the form and table.
export const MOVEMENTS = [
  { key: "recovered", label: "Recovered", sign: -1, hint: "Modem physically recovered" },
  { key: "retained", label: "Recharged / Retained", sign: -1, hint: "Customer recharged, keeping the modem" },
  { key: "inHand", label: "In Hand (field team)", sign: -1, hint: "Collected, sitting with the field team" },
  { key: "notFound", label: "Untraceable", sign: -1, hint: "Customer untraceable — shifted / no longer reachable" },
  { key: "added", label: "New Cases Added", sign: +1, hint: "New case added for recovery" },
];

export const MOVEMENT_KEYS = MOVEMENTS.map((m) => m.key);

export const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? Math.trunc(n) : 0;
};

// closing = opening - recovered - retained - inHand - notFound + added
export const previewClosing = (opening, values = {}) =>
  MOVEMENTS.reduce((acc, m) => acc + m.sign * num(values[m.key]), num(opening));

export const toDateInputValue = (value = new Date()) => {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate(),
  ).padStart(2, "0")}`;
};

export const formatDateLabel = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const monthValue = (value = new Date()) => {
  const d = new Date(value);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const monthLabel = (ym) => {
  if (!ym) return "";
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-IN", {
    month: "long",
    year: "numeric",
  });
};
